<template>
  <div style="width: 100%;">
    <v-bottom-navigation
    	class="transparent"
      v-model="value"
      :color="color"
      grow
      v-if="getUsuarioLMS.roll == 'ALUMNO'"
    >
      <v-btn :to="{ name: 'GruposAlumnos' }" icon v-if="getDatosUsuarioLMS">
        <span>Home</span>

        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'Perfil' }" icon v-if="getDatosUsuarioLMS">
        <span>Perfil</span>

        <v-icon>mdi-account</v-icon>
      </v-btn>

      <!-- <v-btn :to="{ name: 'Chat' }" icon v-if="getDatosUsuarioLMS">
        <span>Chat</span>

        <v-icon>mdi-chat</v-icon>
      </v-btn> -->

      <v-btn :to="{ name: 'Tickets' }" icon>
        <span>Soporte</span>

        <v-icon>mdi-headphones-settings</v-icon>
      </v-btn>

      <v-btn @click="salir()" icon>
        <span>Salir</span>

        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>

    </v-bottom-navigation>

    <v-bottom-navigation
      class="transparent"
      v-model="value"
      :color="color"
      grow
      v-if="getUsuarioLMS.roll == 'TEACHER'"
    >
      <v-btn :to="{ name: 'GruposTeacher' }" icon>
        <span>Grupos</span>

        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'PerfilTeacher' }" icon>
        <span>Perfil</span>

        <v-icon>mdi-account</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'Tickets' }" icon>
        <span>Soporte</span>

        <v-icon>mdi-headphones-settings</v-icon>
      </v-btn>

      <v-btn @click="salir()" icon>
        <span>Salir</span>

        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>

    </v-bottom-navigation>

    <!--Solo mis requisiciones, para Angel Lopez e Ivan-->
    <v-bottom-navigation
      class="transparent"
      v-model="value"
      :color="color"
      grow
      v-if="getUsuarioLMS.roll == 'EDITOR' && getUsuarioLMS.iderp == 31"
    >

      <v-btn :to="{ name: 'IngresarSucursal' }" icon>
        <span>Accesos</span>

        <v-icon>mdi-account</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'MisRequisiciones' }" icon>
        <span>Mis Requisiones</span>

        <v-icon>mdi-folder-multiple</v-icon>
      </v-btn>

      <v-btn @click="salir()" icon>
        <span>Salir</span>

        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>

    </v-bottom-navigation>

    <!--Todo, para Lalo, Karen y yop-->
    <v-bottom-navigation
      class="transparent"
      v-model="value"
      :color="color"
      grow
      v-if="getUsuarioLMS.roll == 'EDITOR' && (getUsuarioLMS.iderp == 334 || getUsuarioLMS.iderp == 28 || getUsuarioLMS.iderp == 623)"
    >

      <v-btn :to="{ name: 'IngresarSucursal' }" icon>
        <span>Accesos</span>

        <v-icon>mdi-account</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'MisRequisiciones' }" icon>
        <span>Mis Requisiones</span>

        <v-icon>mdi-folder-multiple</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'Requisiciones' }" icon>
        
        <span>Requisiciones</span>

        <v-icon>mdi-archive</v-icon>
      </v-btn>

      <v-btn :to="{ name: 'Egresos' }" icon>
        <span>Egresos</span>

        <v-icon>mdi-elevator</v-icon>
      </v-btn>

      <v-btn @click="salir()" icon>
        <span>Salir</span>

        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>

    </v-bottom-navigation>

    <!--Solo Egresos, para Alejandro-->
    <!-- <v-bottom-navigation
      class="transparent"
      v-model="value"
      :color="color"
      grow
      v-if="getUsuarioLMS.roll == 'EDITOR' && (getUsuarioLMS.iderp == 623)"
    >

    <v-btn :to="{ name: 'IngresarSucursal' }" icon>
      <span>Accesos</span>

      <v-icon>mdi-account</v-icon>
    </v-btn>

    <v-btn :to="{ name: 'IngresosEgresos' }" icon>
        <span>Ingresos-Egresos</span>

        <v-icon>mdi-chart-line</v-icon>
    </v-btn>

    <v-btn :to="{ name: 'Egresos' }" icon>
        <span>Egresos</span>

        <v-icon>mdi-elevator</v-icon>
    </v-btn>

    <v-btn @click="salir()" icon>
        <span>Salir</span>

        <v-icon>mdi-exit-to-app</v-icon>
    </v-btn>

    </v-bottom-navigation> -->

  </div>
</template>
<script>
  // Librerías
  import { mapActions, mapGetters } from 'vuex'

  export default {
    data: () => ({ 
      value: 0,
    }),

    methods:{
      ...mapActions( 'login', [ 'salirLogin' ]),
    	salir(){
        this.salirLogin()
    	}
    },

    computed: {
      ...mapGetters( 'login', [ 'getUsuarioLMS', 'getLogeadoLMS', 'getDatosUsuarioLMS' ]),
      
      color () {
        switch (this.value) {
          case 0: return 'primary'
          case 1: return '#157C72'
          case 2: return 'orange'
          case 3: return 'indigo'
          default: return 'blue-grey'
        }
      },
    },
  }
</script>